// extracted by mini-css-extract-plugin
export default {"liveIndicator":"LiveIndicator_liveIndicator__zaeew","liveBlink":"LiveIndicator_liveBlink__qCBMc"};